import { createCRUDHook } from './createCRUDHook';
import { requestQuoteDto } from 'utils/models';
import { ECG_REQUESTQUOTE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<requestQuoteDto>({
  entityName: 'RequestQuote',
  endpoint: ECG_REQUESTQUOTE,
});

export const RequestQuoteContext = Context;
export const useRequestQuoteManager = useManager;
export const useRequestQuote = useConsumer;
